let base = window._env_.VUE_APP_ADMIN_HOST

// ========== 培训管理 ==========
export const queryTrainingInstruction = params => {
  return axios.post(`${base}/training_instruction/query`, params)
}

export const queryTrainingInstructionSelect = params => {
  return axios.post(`${base}/training_instruction/query_select`, params)
}

export const getTrainingInstruction = params => {
  return axios.get(`${base}/training_instruction/get_${params.id}`, { params })
}

export const createTrainingInstruction = params => {
  return axios.post(`${base}/training_instruction/create`, params)
}

export const updateTrainingInstruction = params => {
  const { id, ...rest } = params
  return axios.post(`${base}/training_instruction/update_${id}`, rest)
}

export const enableTrainingInstruction = id => {
  return axios.post(`${base}/training_instruction/enable_${id}`)
}

export const disableTrainingInstruction = id => {
  return axios.post(`${base}/training_instruction/disable_${id}`)
}

export const deleteTrainingInstruction = id => {
  return axios.post(`${base}/training_instruction/delete_${id}`)
}

export const queryTrainingInstructionBatchHistory = params => {
  return axios.post(`${base}/training_instruction/query_batch_history`, params)
}

export const queryTrainingInstructionRecord = params => {
  return axios.post(`${base}/training_instruction_record/query`, params)
}

export const queryTrainingInstructionExamRecord = params => {
  return axios.post(`${base}/training_instruction_exam_record/query`, params)
}

export const getTrainingInstructionExamRecord = params => {
  return axios.get(`${base}/training_instruction_exam_record/get_${params.id}`, { params })
}

// ========== 培训分组 ==========
export const queryTrainingInstructionGroupAll = params => {
  return axios.post(`${base}/training_instruction_group/query_all`, params)
}

export const getTrainingInstructionGroup = params => {
  return axios.get(`${base}/training_instruction_group/get_${params.id}`, { params })
}

export const deleteTrainingInstructionGroup = id => {
  return axios.post(`${base}/training_instruction_group/delete_${id}`)
}

// ========== 知识库 ==========
export const queryTrainingKnowledge = params => {
  return axios.post(`${base}/training_knowledge/query`, params)
}

export const getTrainingKnowledgeTable = params => {
  return axios.post(`${base}/training_knowledge/query`, params)
}

export const getTrainingKnowledgeDetail = params => {
  return axios.get(`${base}/training_knowledge/get_${params.id}`, params)
}

export const getTrainingKnowledge = params => {
  return axios.get(`${base}/training_knowledge/get_${params.id}`, { params })
}

export const updateTrainingKnowledge = params => {
  return axios.post(`${base}/training_knowledge/edit_${params.id}`, params)
}

export const createTrainingKnowledge = params => {
  return axios.post(`${base}/training_knowledge/create`, params)
}

export const banTrainingKnowledge = id => {
  return axios.post(`${base}/training_knowledge/ban_${id}`)
}

export const activeTrainingKnowledge = id => {
  return axios.post(`${base}/training_knowledge/active_${id}`)
}

// ========== 教程 ==========
export const queryUserTrainingCourse = params => {
  return axios.post(`${base}/training_course/query`, params)
}

export const getTrainingCourse = params => {
  return axios.get(`${base}/training_course/get_${params.id}`, { params })
}

export const createTrainingCourse = params => {
  return axios.post(`${base}/training_course/create`, params)
}

export const updateTrainingCourse = params => {
  const { id, ...rest } = params
  return axios.post(`${base}/training_course/edit_${id}`, rest)
}

export const onlineTrainingCourse = id => {
  return axios.post(`${base}/training_course/online_${id}`)
}

export const offlineTrainingCourse = id => {
  return axios.post(`${base}/training_course/offline_${id}`)
}

export const banTrainingCourse = id => {
  return axios.post(`${base}/training_course/ban_${id}`)
}

export const activeTrainingCourse = id => {
  return axios.post(`${base}/training_course/active_${id}`)
}

// ========== 实习生教程 ==========

export const queryInternTrainingCourse = params => {
  return axios.post(`${base}/training_course_intern/query`, params)
}

export const createInternTrainingCourse = params => {
  return axios.post(`${base}/training_course_intern/create`, params)
}

export const updateInternTrainingCourse = params => {
  const { id, ...rest } = params
  return axios.post(`${base}/training_course_intern/edit_${id}`, rest)
}

export const getInternTrainingCourse = params => {
  return axios.get(`${base}/training_course_intern/get_${params.id}`, { params })
}

export const onlineInternTrainingCourse = id => {
  return axios.post(`${base}/training_course_intern/online_${id}`)
}

export const offlineInternTrainingCourse = id => {
  return axios.post(`${base}/training_course_intern/offline_${id}`)
}

export const banInternTrainingCourse = id => {
  return axios.post(`${base}/training_course_intern/ban_${id}`)
}

export const activeInternTrainingCourse = id => {
  return axios.post(`${base}/training_course_intern/active_${id}`)
}

export const uploadInternAssignment = params => {
  const formData = new FormData()
  formData.append('mode', params.mode)
  formData.append('file', params.file)
  return axios.post(`${base}/training_course_intern/upload_intern_assignment`, formData)
}

export const getSelfTrainingCourses = params => {
  return axios.post(`${base}/training_course_intern/get_self_courses`, params)
}

export const getTrainingSignedOssUrl = params => {
  return axios.post(`${base}/training/get_signed_oss_url`, params)
}

// ========== 零工考试 ==========
export const queryTrainingExamination = params => {
  return axios.post(`${base}/training_examination/query`, params)
}

export const getTrainingExamination = params => {
  return axios.get(`${base}/training_examination/get_${params.id}`, { params })
}
// ========== 实习生考试 ==========
export const getTrainingExaminationIntern = params => {
  return axios.get(`${base}/training_examination_intern/get_${params.id}`, { params })
}

export const queryTrainingExaminationInternRecord = params => {
  return axios.post(`${base}/training_examination_intern_record/query`, params)
}

export const getTrainingExaminationInternRecord = params => {
  return axios.get(`${base}/training_examination_intern_record/get_${params.id}`)
}

export const getSelfTrainingExams = params => {
  return axios.post(`${base}/training_examination_intern/get_self_exams`, params)
}

export const startSelfTrainingExam = params => {
  return axios.post(`${base}/training_examination_intern/start_${params.id}`)
}

// 获取考试会话信息
export const getSelfTrainingExam = params => {
  return axios.post(`${base}/training_examination_intern/get_exam_${params.id || params.exam_id}`, params)
}

export const getSelfTrainingExamResult = params => {
  return axios.post(`${base}/training_examination_intern/get_result_${params.record_id}`, params)
}

export const saveSelfTrainingExamDraft = params => {
  return axios.post(`${base}/training_examination_intern/save_draft`, params)
}

export const submitSelfTrainingExam = params => {
  return axios.post(`${base}/training_examination_intern/submit`, params)
}

export const queryInternTrainingExamination = params => {
  return axios.post(`${base}/training_examination_intern/query`, params)
}

export const getInternTrainingExamination = params => {
  return axios.get(`${base}/training_examination_intern/get_${params.id}`, { params })
}

export const createTrainingExaminationIntern = params => {
  return axios.post(`${base}/training_examination_intern/create`, params)
}

export const updateTrainingExaminationIntern = params => {
  const { id, ...rest } = params
  return axios.post(`${base}/training_examination_intern/edit_${id}`, rest)
}

export const onlineTrainingExaminationIntern = id => {
  return axios.post(`${base}/training_examination_intern/online_${id}`)
}

export const offlineTrainingExaminationIntern = id => {
  return axios.post(`${base}/training_examination_intern/offline_${id}`)
}

export const banTrainingExaminationIntern = id => {
  return axios.post(`${base}/training_examination_intern/ban_${id}`)
}

export const activeTrainingExaminationIntern = id => {
  return axios.post(`${base}/training_examination_intern/active_${id}`)
}

export const uploadInternExaminationAssignment = params => {
  const formData = new FormData()
  formData.append('mode', params.mode)
  formData.append('file', params.file)
  return axios.post(`${base}/training_examination_intern/upload_intern_assignment`, formData)
}
// ========== 题目 ==========
export const queryTrainingQuestion = params => {
  return axios.post(`${base}/training_question/query`, params)
}

export const getTrainingQuestion = params => {
  return axios.get(`${base}/training_question/get_${params.id}`, { params })
}

export const createTrainingQuestion = params => {
  return axios.post(`${base}/training_question/create`, params)
}

export const updateTrainingQuestion = params => {
  const { id, ...rest } = params
  return axios.post(`${base}/training_question/edit_${id}`, rest)
}

export const banTrainingQuestion = id => {
  return axios.post(`${base}/training_question/ban_${id}`)
}

export const activeTrainingQuestion = id => {
  return axios.post(`${base}/training_question/active_${id}`)
}


export const createTrainingExamination = params => {
  return axios.post(`${base}/training_examination/create`, params)
}

export const updateTrainingExamination = params => {
  const { id, ...rest } = params
  return axios.post(`${base}/training_examination/edit_${id}`, rest)
}

export const onlineTrainingExamination = id => {
  return axios.post(`${base}/training_examination/online_${id}`)
}

export const offlineTrainingExamination = id => {
  return axios.post(`${base}/training_examination/offline_${id}`)
}

export const banTrainingExamination = id => {
  return axios.post(`${base}/training_examination/ban_${id}`)
}

export const activeTrainingExamination = id => {
  return axios.post(`${base}/training_examination/active_${id}`)
}



// WEBPACK FOOTER //
// ./src/views/training/training.api.js